import React, { useState } from 'react';
import './AdminForgotPassword.css';
import { API_BASE_URL } from '../config/apiConfig';

function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [token, setToken] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await res.json();
      setMessage(data.message || 'Failed to generate token');
      setToken(data.token || '');
    } catch {
      setMessage('Network error');
    }
  };

  return (
    <form className="forgot-password-form" onSubmit={handleSubmit}>
      <h2>🧵 Forgot Password</h2>
      <input type="email" placeholder="Enter your registered email" value={email} onChange={e => setEmail(e.target.value)} required />
      <button type="submit">Generate Reset Token</button>
      {message && <p className="forgot-password-message">{message}</p>}
      {token && <p><strong>Reset Token:</strong> {token}</p>}
    </form>
  );
}

export default AdminForgotPassword;
